import React, { useState,Component } from 'react';
import axios from 'axios';
import { setUserSession } from '../utils/Common';
import { BrowserRouter, Switch, Route, NavLink } from 'react-router-dom';
import {Footer} from 'react-materialize';
import DataService from "../services/data.service";
import Message from '../component/Message';
import Loading from '../component/loading';
import { withRouter } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory'
import Help_Popup from "../component/Help_Popup";
import moment from 'moment'

class Renewal_Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading:true,
      height:"200px",
      products: [],
      count:0,
      salestax:0.00,
      subtotal:0.00,
      total:0.00,
      showmessage:false,
      show_page:false,
      showhelp:false,
      payload:{"lineItems": {}},
     
     
    }
    this.handle_message = this.handle_message.bind(this);
    this.handle_loading = this.handle_loading.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handlehelp = this.handlehelp.bind(this);
    this.calculateFinalTotal = this.calculateFinalTotal.bind(this);
    this.calculate_payload_data = this.calculate_payload_data.bind(this); 
   
  }
  componentWillMount(){
    if(window.innerWidth<600)
    {
      this.setState({height: window.innerHeight-560 + 'px'});
    }
    else
    {
      this.setState({height: window.innerHeight-380 + 'px'});
    }
   
  }
  calculateTotal(input, checked, tax, line_index, opt_index) {
    let { subtotal } = this.state;
    let { salestax } = this.state;

    if (!checked) {
      subtotal = (parseFloat(subtotal) + parseFloat(input)).toFixed(2);
      salestax = (parseFloat(salestax) + parseFloat(tax)).toFixed(2);
      var total = (parseFloat(subtotal) + parseFloat(salestax)).toFixed(2);
    } else {
      subtotal = (parseFloat(subtotal) - parseFloat(input)).toFixed(2);
      salestax = (parseFloat(salestax) - parseFloat(tax)).toFixed(2);
      var total = (parseFloat(subtotal) + parseFloat(salestax)).toFixed(2);
    }

    this.setState({
      subtotal,
    });
    this.setState({
      salestax,
    });
    this.setState({
      total: total,
    });

    Object.keys(this.state.payload.lineItems).map((item, index) => {
      if (item == line_index) {
        this.state.payload.lineItems[item].optional.map(
          (opt_item, opt_index_no) => {
            if (opt_index_no == opt_index) {
              if (!checked) {
                opt_item.checked = true;
              } else {
                opt_item.checked = false;
              }
            }
          }
        );
      }
    });
  }
  calculate_payload_data() {
    if (this.state.payload != undefined) {
      var subtotal = 0;
      var tax = 0;
      Object.keys(this.state.payload.lineItems).map((item, index) => {
        var amount = parseFloat(this.state.payload.lineItems[item].amount);
        subtotal = (+subtotal + amount).toFixed(2);
        var saletax = parseFloat(this.state.payload.lineItems[item].tax);
        tax = (+tax + saletax).toFixed(2);
      });
      var count = Object.keys(this.state.payload.lineItems).length;
      this.setState({ count: count });
      this.setState({ subtotal: subtotal });

      this.setState({ salestax: tax });
      this.calculateFinalTotal(subtotal, tax);
    }
  }
  calculateFinalTotal(subtotal, tax) {
    var total = (parseFloat(subtotal) + parseFloat(tax)).toFixed(2);
    this.setState({ total: total });
  }
  handleClick() {
    console.log("Click happened");
    var data = this.state;
    this.props.history.push({
      pathname: "/payment",
      data,
    });
  
  }
  handlehelp() {
    
    this.setState({ showhelp: !this.state.showhelp });
  }
  handle_message() {
    
    this.setState({ showmessage: !this.state.showmessage });
  }
  handle_reload() {
  
    this.setState({ showmessage: !this.state.showmessage });
  }
  handle_message() 
  {
    this.setState({showmessage:!this.state.showmessage})
  }
  handle_loading()
  {
    this.setState({loading:!this.state.loading})
  }
 
  
  componentDidMount() {
    
    const history = createHistory();
    if (history.location.state && history.location.state.transaction) {
        let state = { ...history.location.state };
        delete state.transaction;
        history.replace({ ...history.location, state });
    }
    if(this.props.location.payment_page!=undefined &&this.props.location.payment_page.page!=undefined && this.props.location.payment_page.page=="payment")
    {
       console.log("from back")
       var salestax=this.props.location.payment_page.salestax
       var subtotal=this.props.location.payment_page.subtotal
       var total=this.props.location.payment_page.total
       var count=this.props.location.payment_page.count
       let payload = this.props.location.payment_page.payload
      // var payload_data=JSON.parse(payload)
       this.setState({salestax:salestax,
         subtotal:subtotal,
         total:total,
         count:count,
         payload:payload
       })
       this.setState({showmessage:false,show_page:true});
       this.setState({loading :false});
    }
    else
    {
      this.setState({loading :true});
      console.log("first0103")
      DataService.getPayload().then(
        
        response => {
          let confirmationId= response.data.confirmationId;
          let amount= response.data.amount;
          let transactionDate= response.data.transactionDate;
     
          let data={
            confirmationId:confirmationId,
            amount:amount,
            transactionDate:transactionDate
          }
          if(response.data.paid)
          {
            this.props.history.push({
              pathname: '/success',
              data
            });
          }
          else
          {
            let exp=parseInt(new Date() / 1000) > parseInt(response.data.paymentExpirationGMT);
            if(exp)
            {
              this.props.history.push({
                pathname: '/expiry',
                
              });
            }
            else
            {
              console.log(response.data)
              console.log("Okay1200/26")
              this.setState({showmessage:false,show_page:true});
              this.setState({
                payload: response.data
              }, () => {
              this.calculate_payload_data();
              this.setState({loading :false});
              this.setState({showmessage:false,show_page:true});
         
            });
            }
        
          }
     
        },
        error => {
          this.setState({content:(error.response && error.response.data) || error.message ||error.toString()});
          this.setState({showmessage:true,show_page:false});
          this.setState({loading :false});
          this.props.history.push({
            pathname: '/payload_not_found'
          });
        }
      );
     
    }
   

  }
 
  calculateFinalTotal(subtotal,tax)
  {
    var total = (parseFloat(subtotal) + parseFloat(tax)).toFixed(2);
    this.setState({total:total})
  }
  calculate_payload_data()
  { 
     if(this.state.payload!=undefined)
    {
      var subtotal=0;
      var tax=0;
      Object.keys(this.state.payload.lineItems).map((item,index) => {
               
               var amount= parseFloat(this.state.payload.lineItems[item].amount);
               subtotal = (+subtotal + amount).toFixed(2);
               var saletax= parseFloat(this.state.payload.lineItems[item].tax);
               tax = (+tax + saletax).toFixed(2);
      })
      var count=Object.keys(this.state.payload.lineItems).length;
      this.setState({count:count});
      this.setState({subtotal:subtotal});
    
      this.setState({salestax:tax});
      this.calculateFinalTotal(subtotal,tax);



      Object.keys(this.state.payload.lineItems).map((item,index) => {

      
        this.state.payload.lineItems[item].optional && this.state.payload.lineItems[item].optional.map((opt_item,opt_index_no) => {
 
           opt_item.checked=false
         }) 
       
     
      })
    }

  }
    render() {
        return (
          <div className="">
          <div style={this.state.show_page ? {} : {display: 'none'}} className=" mt-2 col-md-12 col-sm-12 page_padding">
            <h3 className="renewal_font">FUR SERVICE RENEWAL NOTICE</h3>
  
        
            <div className="row mt-2">
            <div class=" mb-2  text-left size_14  d-block d-md-none cus_back">
                  <div class="cus_info_content_padding">

                    <div className="row col-md-12  col-sm-12 mt-1 mb-2 col-12">
                      <div className="col-md-12 col-sm-12 col-6">
                        <label class="cus_info_title">Customer Info</label>
                      </div>

                    </div>
                    <div className="row col-md-12  col-sm-12 mt-1 mb-3 col-12">
                      <div className="col-md-4 col-sm-4 col-3">
                        <label class="cus_padding">Name : </label>
                      </div>
                      <div className="col-md-8 col-sm-8 col-9">
                        <label class="cus_padding cus_info_bold">{this.state.payload.firstName +
                          " " +
                          this.state.payload.lastName}</label>
                      </div>
                      <div className="col-md-4 col-sm-4 col-3">
                        <label class="cus_padding">Email :</label>
                      </div>
                      <div className="col-md-8 col-sm-8 col-9">
                        <label class="cus_padding cus_info_bold"> {this.state.payload.customerEmail}</label>
                      </div>
                      <div className="col-md-4 col-sm-4 col-3">
                        <label class="cus_padding">Phone :  </label>
                      </div>
                      <div className="col-md-8 col-sm-8 col-9">
                        <label class="cus_padding cus_info_bold">  {this.state.payload.customerPhone}
                        </label>
                      </div>
                      <div className="col-md-4 col-sm-4 col-3">
                        <label class="cus_padding">Order# :</label>
                      </div>
                      <div className="col-md-8 col-sm-8 col-9">
                        <label class="cus_padding cus_info_bold"> {this.state.payload.orderNumber}</label>

                      </div>
                    </div>
                  </div>
            </div>
            <div className="col-md-4 order-2  mb-md-4">
                <div class=" mb-2  text-left size_14 cus_info d-none d-md-block">
                  <div class="cus_info_content_padding">
                    <div className="row col-md-12  col-sm-12 mt-1 mb-3 col-12">
                      <div className="col-md-12 col-sm-12 col-6">
                        <label class="cus_info_title">Customer Info</label>
                      </div>
                    </div>
                    <div className="row col-md-12  col-sm-12 mt-1 mb-3 col-12">
                      <div className="col-md-4 col-lg-3 col-sm-4 col-6 pr-0">
                        <label class="">Name : </label>
                      </div>
                      <div className="col-md-8 col-lg-9 col-sm-8 col-6 p-0">
                        <label class=" product_info_title">
                          {this.state.payload.firstName +
                            " " +
                            this.state.payload.lastName}
                        </label>
                      </div>
                      <div className="col-md-4 col-lg-3 col-sm-4 col-6 pr-0">
                        <label class="">Email :</label>
                      </div>
                      <div className="col-md-8 col-lg-9 col-sm-8 col-6 p-0">
                        <label class=" product_info_title">
                          {this.state.payload.customerEmail}
                        </label>
                      </div>
                      <div className="col-md-4 col-lg-3 col-sm-4 col-6 pr-0">
                        <label class="">Phone : </label>
                      </div>
                      <div className="col-md-8 col-lg-9 col-sm-8 col-6 p-0">
                        <label class=" product_info_title">
                          {" "}
                          {this.state.payload.customerPhone}
                        </label>
                      </div>
                      <div className="col-md-4 col-lg-3 col-sm-4 col-6 pr-0">
                        <label class="">Order# :</label>
                      </div>
                      <div className="col-md-8 col-lg-9 col-sm-8 col-6 p-0">
                        <label class=" product_info_title">
                          {this.state.payload.orderNumber}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
               
                <div className="row d-none d-md-block">
                <div className="col-12">
                <div className="total_bg1 p-md-3 order_bottom">
            
                  <div className="row p-0 ">
                    <div className=" col-md-8 col-sm-8 col-8 text-left mt-3">
                      <label className="text-left product_info_title">
                        Payment Subtotal{" "} ( {this.state.count} items)
                      </label>
                    
                     
                    </div>
                    <div className="col-md-4 col-sm-4 col-4 mt-3 text-right">
                      <label className="text-right  product_info_title">
                        ${this.state.subtotal}
                      </label>
                    </div>
                  
                  </div>
                  <div className="row  p-0 ">
                    <div className="col-md-8 col-sm-8 col-8 text-left">
                      <label className="text-left product_info_title">
                        Sales Tax{" "}
                      </label>
                      <i
                        class="fa fa-question-circle ml-1"
                        onClick={this.handlehelp}
                        aria-hidden="true"
                      ></i>
                    </div>
                    <div className="col-md-4 col-sm-4 col-4 text-right">
                      <label className="text-right product_info_title">
                        ${this.state.salestax}
                      </label>
                    </div>
                  </div>
  
                  <div className="row  p-0 ">
                  <div className="col-md-12 col-sm-12 col-12 text-left">
                  <hr className=""></hr>
                  </div>
                  
                    <div className="col-md-8 col-sm-8 col-8 text-left">
                      <label className="text-left total_font ">
                        Payment Total
                      </label>
                    </div>
                    <div className="col-md-4 col-sm-4 col-4 text-right">
                      <label className="text-left total_font ">
                        ${this.state.total}
                      </label>
                    </div>
                  </div>
                  <div className="row  p-0 mt-3 ">
                  <div className="col-md-12  text-left">
                    <button
                      type="button"
                      class="btn orange_btn mb-2"
                      onClick={this.handleClick}
                    >
                      PROCEED TO PAYMENT
                    </button>
                    </div>
                  </div>
                </div>
                </div>
                </div>
  
  
            </div>
            <div className="row">
                  <div className="col-md-12 col-sm-12 col-12">
                  <h3 className="text-left size_24 mt-1 review_font">Review </h3>
                  </div>
                    <hr className="line1 mt-1 mb-1"></hr>
                  </div>
            <div className="col-md-8 order-1 renewal_scroll mt-2" style={{height : this.state.height,overflow:"auto"}}>
              {  
                
                this.state.payload.lineItems && Object.keys(this.state.payload.lineItems).map((item, index) => {
                return (
                  <div className="row product_info">
                    <div className="col-md-6 order-md-1">
                      <div className="row" >
                        <div className="col-md-10 text-left mb-1">
                          <label class=" product_info_title">
                            {this.state.payload.lineItems[item].itemDescription}{" "}
                          </label>
                        </div>
                      </div>
                      <div className="row text-left">
                        <div className="col-md-2 col-3">
                          <label class=" grey_text">SKU#:</label>
                        </div>
                        <div className="col-md-8 col-9">
                          <label class=" cus_info_bold">{this.state.payload.lineItems[item].sku}</label>
                        </div>
                      </div>
                      {/* <div className="row text-left">
                        <div className="col-md-2 col-3">
                          <label class=" grey_text">Policy#:</label>
                        </div>
                        <div className="col-md-8 text-left col-9">
                          <label class=" cus_info_bold ">{this.state.payload.lineItems[item].sku}</label>
                        </div>
                      </div> */}
                      <div className="row text-left">
                        <div className="col-md-2 col-3">
                          <label class=" grey_text">FSA#:</label>
                        </div>
                        <div className="col-md-8 text-left col-9">
                          <label class=" cus_info_bold">{this.state.payload.lineItems[item].fsaNo}</label>
                        </div>
                      </div>
                      
                    </div>
                    <div className="col-md-6 order-md-2">
                      <div className="row text-left">
                        <div className="col-md-10">
                          <label class=" product_info_title">
                            Service Included
                          </label>
                        </div>
                      </div>
                      <div className="row text-left">
                        <div className="col-md-4 col-lg-3 col-3">
                          <label class="cus_info_bold">{this.state.payload.lineItems[item].description}</label>
                        </div>
                        <div className="col-md-8 col-lg-9 col-9">
                          <label class="cus_info_bold">${this.state.payload.lineItems[item].amount}</label>
                        </div>
                      </div>
                      <div className="row text-left mt-1" style={this.state.payload.lineItems[item].optional && this.state.payload.lineItems[item].optional.length>0 ? {} : {display: 'none'}}>
                        <div className="col-md-10">
                          <label class=" product_info_title">
                            Optional
                          </label>
                        </div>
                      </div>
                      {
                      this.state.payload.lineItems[item].optional && this.state.payload.lineItems[item].optional.map((opt_item,index_opt) =>{
                      return (
                        <div className="row text-left">
                        <div className="col-md-4 col-lg-3 col-3 ">
                           <input class="form-check-input"
                             type="checkbox"
                             value={ opt_item.checked}
                             defaultChecked={ opt_item.checked}   
                             onClick={() => {this.calculateTotal(opt_item.amount, opt_item.checked,opt_item.taxes,item,index_opt)}}   />
                        <label class="cus_info_bold ml-3">{opt_item.description}</label>
                        </div>
                        <div className="col-md-8 col-9 col-lg-9 text-left ">
                        <label class="cus_info_bold">${parseFloat(opt_item.amount).toFixed(2)} plus tax</label>
                        </div>
                    
                        </div>
                        )
                      }
                      )
                    }
                    </div>
                    <div className="col-md-12 order-md-2">
                      <hr></hr>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="col-md-12 col-12  d-block d-md-none order_bottom order-2">
          
          <div className="col-sm-12 p-0">
              <div className="total_bg1 p-md-3 p-2">
              <div className="row  ">
                <div className="col-12 text-left">
                  <hr className=""></hr>
                  </div>
                  </div>
                <div className="row ">
                  <div className=" col-md-8 col-sm-8 col-8 text-left mt-1 ">
                    <label className="text-left product_info_title">
                      Payment Subtotal{" "} ( {this.state.count} items)
                    </label>
                  
                   
                  </div>
                  <div className="col-md-4 col-sm-4 col-4 mt-3 text-right">
                    <label className="text-right  product_info_title">
                      ${this.state.subtotal}
                    </label>
                  </div>
                
                </div>
                <div className="row  p-0 ">
                  <div className="col-md-8 col-sm-8 col-8 text-left">
                    <label className="text-left product_info_title">
                      Sales Tax{" "}
                    </label>
                    <i
                      class="fa fa-question-circle ml-1"
                      onClick={this.handlehelp}
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div className="col-md-4 col-sm-4 col-4 text-right">
                    <label className="text-right product_info_title">
                      ${this.state.salestax}
                    </label>
                  </div>
                </div>

                <div className="row  p-0 ">
                 
                  <div className="col-md-12 col-sm-12 col-12 text-left">
                  <hr className=""></hr>
                  </div>
                  <div className="col-md-8 col-sm-8 col-8 text-left">
                    <label className="text-left total_font ">
                      Payment Total
                    </label>
                  </div>
                  <div className="col-md-4 col-sm-4 col-4 text-right">
                    <label className="text-left total_font ">
                      ${this.state.total}
                    </label>
                  </div>
                </div>
                <div className="row  p-0 mt-1 ">
                <div className="col-md-12  text-left">
                  <button
                    type="button"
                    class="btn orange_btn mb-2"
                    onClick={this.handleClick}
                  >
                    PROCEED TO PAYMENT
                  </button>
                  </div>
                </div>
              </div>
              </div>
          </div>
            </div>
    
          </div>
          <div style={this.state.showhelp ? {} : { display: "none" }}>
            <Help_Popup handleClose={this.handlehelp} />
          </div>
          <div style={this.state.showmessage ? {} : {display: 'none'}}><Message   handle_message={this.handle_message} /></div>
        </div>
      );
        
    }
  
}
export default withRouter(Renewal_Page);
